import { ExternalDashboardApiService } from './external-dashboard-api.service';

export default angular
  .module('sfMobile.services.external-dashboard-api', ['sfMobile.services.pov'])
  .service('externalDashboardApiService', ExternalDashboardApiService).name;
